import {
  AccountInfo,
  AuthenticationResult,
  Configuration,
  LogLevel,
  PublicClientApplication,
} from "@azure/msal-browser";
import { API_ID, CLIENT_ID, SESSION_STORAGE_KEYS, TENANT } from "./constants/constants";
// Browser check variables
// If you support IE, our recommendation is that you sign-in using Redirect APIs
// If you as a developer are testing using Edge InPrivate mode, please add "isEdge" to the if check
// const ua = window.navigator.userAgent;
// const msie = ua.indexOf("MSIE ");
// const msie11 = ua.indexOf("Trident/");
// const msedge = ua.indexOf("Edge/");
// const firefox = ua.indexOf("Firefox");
// const isIE = msie > 0 || msie11 > 0;
// const isEdge = msedge > 0;
// const isFirefox = firefox > 0; // Only needed if you need to support the redirect flow in Firefox incognito

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT}`,
    redirectUri: "/",
    postLogoutRedirectUri: "/",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: LogLevel, message: string, containsPii: boolean) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: [`api://${API_ID}/Mobile.Access`],
};

export const graphRequest = {
  scopes: ["User.Read"],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMePhotoEndpoint: "https://graph.microsoft.com/v1.0/me/photo/$value",
};

export const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();

function handleResponse(response: AuthenticationResult | null) {
  if (response !== null) {
    msalInstance.setActiveAccount(response.account);

    const redirectPath = sessionStorage.getItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);

    if (window.location.pathname === "/") window.location.replace(redirectPath ?? "/household");
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.REDIRECT_PATH);
  } else {
    const currentAccounts = msalInstance.getAllAccounts();

    if (currentAccounts.length === 0) {
      //
    } else if (currentAccounts.length > 1) {
      // Add choose account code here
    } else if (currentAccounts.length === 1) {
      msalInstance.setActiveAccount(currentAccounts[0] as AccountInfo);
    }
  }
}

msalInstance.handleRedirectPromise().then(handleResponse);
